import { Box, ContentBlock, PageBlock } from 'braid-design-system';

interface LayoutProps {
  isFullWidth?: boolean;
  isBudgetPage?: boolean;
}

const Layout: React.FC<React.PropsWithChildren<LayoutProps>> = ({
  children,
  isFullWidth = false,
  isBudgetPage = false,
}) => (
  <PageBlock width="full">
    <ContentBlock width={isFullWidth ? 'large' : 'medium'}>
      <Box marginTop={isBudgetPage ? ['xxxlarge'] : ['xlarge', 'xxlarge']}>
        {children}
      </Box>
    </ContentBlock>
  </PageBlock>
);

export default Layout;
